import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import ProtectedRoute from "../components/ProtectedRoute";
import "../css/Suggestions.css";

export const Route = createFileRoute("/suggestions")({
  component: Suggestions,
});

function Suggestions() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    suggestion: "",
    wantsToBeCreator: false
  });
  const isMobileView = typeof window !== "undefined" && window.innerWidth <= 640;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const SUBSCRIBE_ENDPOINT = "https://34-26-2-238.nip.io/subscribe";
      
      // Format: $$$Suggestion: <name>${name}<email>${email}<suggestion>${suggestion}<creator>${wantsToBeCreator}
      const combinedData = `$$$Suggestion: <name>${formData.name.trim()}<email>${formData.email.trim()}<suggestion>${formData.suggestion.trim()}<creator>${formData.wantsToBeCreator}`;
      
      const formDataToSend = new FormData();
      formDataToSend.append('email', combinedData);
      
      const response = await fetch(SUBSCRIBE_ENDPOINT, {
        method: 'POST',
        body: formDataToSend,
      });
      
      if (response.ok) {
        alert('Suggestion submitted successfully!');
        // Redirect to courses page after successful submission
        navigate({ to: '/courses' });
      } else {
        alert('Error submitting suggestion. Please try again.');
      }
    } catch {
      alert('Failed to submit suggestion. Please try again.');
    }
  };

  return (
    <ProtectedRoute>
      <div className="suggestions-container">
        {/* Navigation */}
        <div style={{ marginBottom: 32 }}>
          <Link className="link-button" to="/courses">
            ← Back to Courses
          </Link>
        </div>
        
        {/* Header */}
        <div style={{ marginBottom: isMobileView ? 24 : 40 }}>
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: 700,
              marginBottom: 16,
              textAlign: isMobileView ? "center" : "left",
            }}
          >
            Share Your Suggestions
          </h1>
          <p style={{ opacity: 0.9, fontSize: "1.1rem", maxWidth: 600 }}>
            We value your feedback! Let us know what courses you'd like to see, 
            how we can improve the platform, or if you're interested in creating content.
          </p>
        </div>

        {/* Form */}
        <div className="suggestions-form">
          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <div style={{ marginBottom: 24 }}>
              <label>
                Your Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your name"
              />
            </div>

            {/* Email Field */}
            <div style={{ marginBottom: 24 }}>
              <label>
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your email"
              />
            </div>

            {/* Suggestion Field */}
            <div style={{ marginBottom: 24 }}>
              <label>
                Your Suggestion
              </label>
              <textarea
                name="suggestion"
                value={formData.suggestion}
                onChange={handleChange}
                required
                rows={6}
                placeholder="Tell us about your course ideas, site improvements, or any other feedback..."
              />
            </div>

            {/* Creator Checkbox */}
        <div style={{ marginBottom: isMobileView ? 20 : 32 }}>

              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="wantsToBeCreator"
                  checked={formData.wantsToBeCreator}
                  onChange={handleChange}
                />
                <span>Do you wish to be considered to be a course creator?</span>
              </label>
            </div>

            {/* Submit Button */}
            <button type="submit">
              Send Suggestion
            </button>
          </form>
        </div>
      </div>
    </ProtectedRoute>
  );
}